<template>
  <div class="container-fluid carouselOne carousel-owlOne position-relative">

    <div class="row">
      <div class="col-12 d-none d-lg-flex carouselContainer">
        <carousel :nav="false" :dots="true" :autoWidth=true :loop=true :responsive="{0:{items:1,stagePadding: 0},1000:{items:2,stagePadding: 100}}">
          <prospetime style="width:455px"></prospetime>

          <temperatura style="width:455px"></temperatura>

          <ordine style="width:455px"></ordine>

          <amestecare style="width:455px"></amestecare>

          <mixare style="width:455px"></mixare>

          <template #customPaging>

            <div class="custom-dot">
              <!-- {{ page }} -->
            </div>
          </template>

        </carousel>
      </div>
    </div>

    <div class="d-block d-lg-none carouselContainer">
      <carousel :nav="false" :items=1 :autoHeight=true>
        <prospetime></prospetime>

        <temperatura></temperatura>

        <ordine></ordine>

        <amestecare></amestecare>

        <mixare></mixare>

        <template #customPaging>

          <div class="custom-dot">
            <!-- {{ page }} -->
          </div>
        </template>

      </carousel>
    </div>

  </div>
</template>

<script>

// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
//import cards
import Prospetime from "./CardSlick/Prospetime.vue"
import Temperatura from "./CardSlick/Temperatura.vue"
import Ordine from "./CardSlick/Ordine.vue"
import Amestecare from "./CardSlick/Amestecare.vue"
import Mixare from "./CardSlick/Mixare.vue"
import carousel from 'vue-owl-carousel'

export default {
  name: 'MyComponent',
  props: ["mobile_component"],
  components: {
    'prospetime': Prospetime,
    'temperatura': Temperatura,
    'ordine': Ordine,
    'amestecare': Amestecare,
    'mixare': Mixare,
    carousel
  },

  data() {
    return {

    }
  },
}
</script>
<style scoped lang="scss">

.carouselOne {
  margin-top: 80px;
  min-height: 500px;

  .bk-gray-dark{
    margin-right: 20px !important;
  }

  .carouselContainer {
    //position: absolute;
    //top: 0;
    //right: 0;
    width: 100%;
    height: 100%;
    padding-right: 0;

    .bk-gray-dark {
      border-radius: 20px;
      min-height: 340px;
      padding: 30px;
      position: relative;
      margin: 60px 0;

      @media only screen and (max-width: 992px) {
        width: 100% !important;
        max-height: 100%;
        min-height: auto;
        padding-top: 45px;
      }

      p {
        font-size: 16px;
        font-weight: 600;
        color: #029FE3;

      }

      span {
        font-size: 14px;
        font-weight: 500;
        color: #029FE3;
      }
    }

    @media only screen and (max-width: 768px) {

      padding-right: 15px;

    }

    .slick-slider {
      ::v-deep .slick-dots {
        width: inherit;
        right: 25%;

        li {
          margin: 3px;
          width: initial;
        }
      }
    }

    .slick-list {
      background-color: red;
      margin: 0 -150px 0 0;


      .slick-slide {
        display: block;
        margin-right: 30px;

        .bk-blue-light {
          background: #F2F0ED;
          border-radius: 20px;
          padding-top: 65px;
          width: 420px !important;
          min-height: 380px;
          max-height: 380px;
          position: relative;
          @media only screen and (max-width: 768px) {
            width: 100% !important;
            max-height: 100%;
            min-height: auto;
            padding-top: 45px;
          }

          p {
            font-size: 16px;
            font-weight: 600;
            color: #029FE3;
          }

          span {
            font-size: 14px;
            font-weight: 500;
            color: #029FE3;
          }
        }


      }
    }
  }
}

ul {
  .custom-dot {
    display: inline-block;
    font-size: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    border: none;
    background: #029FE3;
    outline: none;
    transition: all 0.2s ease;
    cursor: pointer;
    opacity: 0.5;

  }

  .slick-active {
    .custom-dot {
      opacity: 1;
      width: 24px;
      border-radius: 10px;
    }
  }
}

@media only screen and (max-width: 768px) {
  .carouselOne {
    //min-height: 150vh;
    margin-top: 0;

    ::v-deep .slick-slide {
      float: none !important;
    }
  }
}

@media only screen and (max-width: 668px) {
  .carouselOne {
    //min-height: 170vh;
  }
}

@media only screen and (max-width: 576px) {
  .carouselOne .carouselContainer .owl-carousel.owl-drag .owl-item{
    width: 290px !important;
  }

  .carouselOne .carouselContainer .bk-gray-dark {
    padding: 10px;
    width: 95% !important;
  }
  .carouselOne {
    //min-height: 150vh;
  }
}

@media only screen and (max-width: 450px) {
  .carouselOne {
    //min-height: 246vh;
  }
}

@media only screen and (max-width: 425px) {
  .carouselOne {
    //min-height: 280vh;
  }
}

@media only screen and (max-width: 375px) {
  .carouselOne {
    //min-height: 180vh;
  }
}

@media only screen and (max-width: 350px) {
  .carouselOne {
    min-height: 400px;
  }
}
</style>
